export default "__VITE_ASSET__knOM$FR6__"